import React from "react";
import { Card } from "uikit/components";
import cx from "classnames";
import styles from "./ValueHeaderCard.module.styl";
import { number, string } from "prop-types";
import { percentageLevels } from "utils/indicator/indicatorSettings";

export default function ValueHeaderCard({ headerPercent, headerText, children }) {
    const indicatorStyle = percentageLevels.indicatorColorWithOverload(headerPercent);

    return (
        <Card borderRadius={"giant"} padding={"none"}>
            <div className={cx(styles.header, indicatorStyle.backgroundStyle)}>
                <div className={styles.percent}>{headerPercent}%</div>
                <div className={styles.percentText}>{headerText}</div>
            </div>
            {children}
        </Card>
    );
}

ValueHeaderCard.propTypes = {
    headerPercent: number.isRequired,
    headerText: string.isRequired,
};
